import { BRAND_COLOR } from '@/theme'
import { useColorScheme } from 'nativewind'

export default function useBrandColor() {
  const { colorScheme } = useColorScheme()
  return colorScheme === 'dark' ? BRAND_COLOR.dark : BRAND_COLOR.light
}
